import { styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import React from "react";

const TextFieldBox = ({
  multiline = false,
  rows = 4,
  type = "text",
  value = "",
  name,
  handleChange,
  placeholder = "placeholder",
  disabled = false,
  variant = "outlined",
  required = false,
  size = "small",
  ...props
}) => {
  return (
    <Text
      disabled={disabled}
      id={name}
      value={value}
      name={name}
      placeholder={placeholder}
      onChange={handleChange}
      size={size}
      fullWidth
      multiline={multiline}
      required={required}
      rows={rows}
      type={type}
      variant={variant}
      {...props}
    />
  );
};

const Text = styled(TextField)(({ theme }) => ({
  "& label": {
    color: theme.palette.text.primary, // Label color
  },
  "& label.Mui-focused": {
    color: theme.palette.text.primary, // Color when input is focused
  },
  "& fieldset": {
    border: `1px solid #DCDCDC !important`,
    borderRadius: 8,
  },
  "& input[type=number]": {
    "-moz-appearance": "textfield", // Firefox
  },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
    {
      "-webkit-appearance": "none",
      margin: 0, // Chrome, Safari, Edge, Opera
    },
  "& .MuiInputLabel-root": {
    color: theme.palette.text.default, // Label color
  },
  "& input": {
    color: theme.palette.text.primary, // Default input text color
  },
  "& input.Mui-disabled": {
    color: "#000 !important", // Force black text when disabled
    "-webkit-text-fill-color": "#000 !important", // Ensures the black text color in Safari
  },
}));

export default TextFieldBox;
